// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveFilter_wrapper__3azz_","text":"ActiveFilter_text__29NN4","closeIcon":"ActiveFilter_closeIcon__FPW1j"};